export default __webpack_public_path__ + "static/media/grafema_coimbra-2027-contest_16.5350f6a3.jpg";